import { createSelector } from 'reselect';

import { initialState } from './slice';

const selectOpenTasksDomain = (state) => state.openTasks ?? initialState;

const openTasksSelector = createSelector(selectOpenTasksDomain, (substate) => substate);

export { openTasksSelector };
